import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";

interface Props {
  scheduledDate: string;
  formatDate: (date: string) => string;
}

const CertificationScheduledDateLabelField: React.FC<Props> = ({
  scheduledDate,
  formatDate,
}) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.certification.scheduledText,
        label: formatDate(scheduledDate),
      }}
    />
  );
};

export default React.memo(CertificationScheduledDateLabelField);
